import {
  APIProvider,
  Map,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import { PoiMarkers } from "./PoiMarkers";
import { MapRoute } from "./MapRoute";
import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
// import { mapRange } from "../../../helpers/utilities";
import { toast } from "react-toastify";
const MapRefSetter = ({
  mapRefToSet,
  mapsLibraryRef,
  coreLibraryRef,
  geometryLibraryRef,
}) => {
  const mapsLibrary = useMapsLibrary("maps");
  const coreLibrary = useMapsLibrary("core");
  const geometryLibrary = useMapsLibrary("geometry");

  const mapRef = useMap();
  if (mapRefToSet) {
    mapRefToSet.current = mapRef;
  }
  if (mapsLibraryRef) {
    mapsLibraryRef.current = mapsLibrary;
  }
  if (coreLibraryRef) {
    coreLibraryRef.current = coreLibrary;
  }
  if (geometryLibraryRef) {
    geometryLibraryRef.current = geometryLibrary;
  }
  return null;
};
// const baseDistanceThreshold = 0.000001;
const getDistanceThresholdForZoomLevel = (zoomLevel) => {
  if (zoomLevel >= 19) {
    return 0.00000001;
  }
  if (zoomLevel >= 16) {
    return 0.00000025;
  }
  if (zoomLevel >= 15) {
    return 0.0000015;
  }
  if (zoomLevel >= 12) {
    return 0.00001;
  }
  if (zoomLevel >= 11) {
    return 0.00005;
  }
  if (zoomLevel >= 10) {
    return 0.0005;
  } else {
    return 0.00005;
  }
};
const getDistanceMultiplierForZoomLevel = (zoomLevel) => {
  const multipliersForZoomLevel = {
    1: 2,
    2: 1.9,
    3: 1.8,
    4: 1.7,
    5: 1.6,
    6: 1.5,
    7: 1.4,
    8: 1.3,
    9: 1.2,
    10: 1.1,
    11: 1,
    12: 0.5,
    13: 0.5,
    14: 0.2,
    15: 0.2,
    16: 0.1,
    17: 0.1,
    18: 0.1,
    19: 0.1,
    20: 0.1,
  };
  return multipliersForZoomLevel[zoomLevel] ?? 1;
};
const drawingMethods = {
  autocompleteWithOverlay: "autocompleteWithOverlay",
  finishLine: "finishLine",
};
const distanceSquared = (x1, y1, x2, y2) => {
  return Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
};
export const DiliMap = ({
  initialCenterCoord, // = { lat: 29.8356857, lng: -95.7908324 },
  markers, //[{key, location:{lat,lng}}]
  hoveredMarker,
  route,
  legStatuses,
  simpleRoute,
  mapRef,
  zoomControl = true,
  apiKey,
  assignOrders,
  // selectedPosition,
  // viewUnassigned,
  showDrawToAssignButton,
}) => {
  const [closeInfoWindowNotif, setCloseInfoWindowNotif] = useState(0);
  const [drawingMethod, setDrawingMethod] = useState(drawingMethods.finishLine);
  const [drawingModeActive, setDrawingModeActive] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);
  const mapsLibraryRef = useRef();
  const coreLibraryRef = useRef();
  const geometryLibraryRef = useRef();
  const mapsLibrary = mapsLibraryRef.current;
  const coreLibrary = coreLibraryRef.current;
  const geometryLibrary = geometryLibraryRef.current;

  const [currentDrawing, setCurrentDrawing] = useState();
  const [currentOverlay, setCurrentOverlay] = useState();
  const [startCircle, setStartCircle] = useState();

  const toggleDrawingMode = () => {
    setDrawingModeActive((prev) => !prev);
    setIsDrawing(false);
    currentDrawing?.setPath([]);
    currentOverlay?.setPath([]);
    startCircle?.setVisible(false);
  };

  // console.log(mapRef.current?.zoom);

  const handleUpdateDrawing = (e) => {
    // just in case
    if (e === undefined) {
      // console.log("mouse move event, e undefined", e);
      return;
    }
    // console.log("mouse move event e", e);
    // console.log("handle update drawing/Map mouse move");
    // console.log(isDrawing);
    const saved = e.detail.latLng;
    // console.log("map hovered", saved);
    // console.log("update error", e.detail);

    if (!isDrawing || saved === undefined || saved === null) {
      return;
    }

    const previousPath = currentDrawing?.getPath()?.getArray(); //the property that holds the array changes names over time, but this function should always get it
    const lastPoint = previousPath[previousPath.length - 1];
    //check if threshold is reached
    const distance =
      Math.pow(saved.lat - lastPoint.lat(), 2) +
      Math.pow(saved.lng - lastPoint.lng(), 2);

    // console.log(distance);
    if (
      distance > getDistanceThresholdForZoomLevel(mapRef.current?.zoom)
      // baseDistanceThreshold * mapRange(mapRef.current?.zoom, 5, 20, 10, 1)
    ) {
      // console.log("mapref zoomlevel", mapRef.current?.zoom);
      // console.log(
      //   "mapped zoomlevel",
      //   getDistanceThresholdForZoomLevel(mapRef.current?.zoom)
      // );
      currentDrawing.setPath([...previousPath, e.detail.latLng]);
      if (drawingMethod === drawingMethods.autocompleteWithOverlay) {
        currentOverlay.setPath([...previousPath, e.detail.latLng]);
      }
    }
    // console.log(e);
  };
  // console.log(currentDrawing?.getPath());
  // console.log("mapref zoomlevel", mapRef.current?.zoom);

  //Start and Stop drawing as separate functions
  //Was thinking to make it so we start on mousedown and stop on mouseup so it's click and hold to draw.
  //However the map component does not expose these events. Might be able to add the event listeners to the map.
  // const startDrawing = (e) => {
  //   if (!drawingModeActive) {
  //     return;
  //   }
  //   currentDrawing.setPath([...currentDrawing.getPath()?.getArray(), e.detail.latLng]);
  //   setIsDrawing(true);
  // };
  // const stopDrawing = (e) => {
  //   if (isDrawing === false) {
  //     return;
  //   }
  //   currentDrawing.setPath([]);
  //   setIsDrawing(false);
  //   setDrawingModeActive(false);
  // };
  const cancelDrawing = (e) => {
    if (!isDrawing) {
      return;
    }
    // console.log(e);
    currentDrawing.setPath([]);
    currentOverlay.setPath([]);
    startCircle?.setVisible(false);
    setIsDrawing(false);
    setDrawingModeActive(false);
    toast.error("Selection Canceled");
  };
  const startOrEndDrawing = (e) => {
    // console.log("Drawing started");
    // console.log("mapref", mapRef.current);
    // console.log("mapref drag", mapRef.current.drag?.());
    // const mapDiv = mapRef.current.getDiv();
    // console.log("mapref div", mapDiv);

    // setCloseInfoWindowNotif((prev) => prev + 1); // if we want to automatically close all info windows if they click anywhere on the map.
    if (!drawingModeActive) {
      return;
    }
    if (isDrawing === false) {
      //if we started the drawing (was false and now will be), put the lat,lng of the spot clicked into the polygon path array.
      // console.log("current drawing path", currentDrawing.getPath());
      currentDrawing.setPath([
        ...currentDrawing?.getPath()?.getArray(),
        e.detail.latLng,
      ]);
      currentOverlay.setPath([
        ...currentDrawing?.getPath()?.getArray(),
        e.detail.latLng,
      ]);
      if (drawingMethod === drawingMethods.finishLine) {
        startCircle?.setVisible(true);
        startCircle?.setRadius(
          500 * getDistanceMultiplierForZoomLevel(mapRef.current?.zoom)
        );
        startCircle?.setCenter(e.detail.latLng);
      }

      setIsDrawing(true);
    }
    if (isDrawing === true) {
      const drawingBounds = new coreLibrary.LatLngBounds();
      //Add the click position that ended the drawing to the path before we do collision detection.
      currentDrawing.setPath([
        ...currentDrawing?.getPath()?.getArray(),
        e.detail.latLng,
      ]);
      const drawingPath = currentDrawing?.getPath();
      if (drawingMethod === drawingMethods.finishLine) {
        // console.log("finish line", drawingPath.getAt(0));
        // const distanceBetweenStartAndEnd = distanceSquared(
        //   e.detail.latLng.lat,
        //   e.detail.latLng.lng,
        //   drawingPath.getAt(0).lat(),
        //   drawingPath.getAt(0).lng()
        // );
        if (drawingMethod === drawingMethods.finishLine) {
          const distanceBetweenStartAndEnd =
            geometryLibrary.spherical.computeDistanceBetween(
              e.detail.latLng,
              drawingPath.getAt(0)
            );
          // console.log(distanceBetweenStartAndEnd);
          if (
            distanceBetweenStartAndEnd >
            1000 * getDistanceMultiplierForZoomLevel(mapRef?.current?.zoom)
          ) {
            toast.error("Please enclose selection.");
            return;
          }
        }
      }
      //Create a bounds containing all of the points in the drawing. Markers outside these bounds are not contained in the polygon and we can ignore them from the more complex point-in-polygon collision detection algorithm.

      // console.log("current drawing path", drawingPath);
      for (let i = 0; i < drawingPath.getLength(); i++) {
        drawingBounds.extend(drawingPath.getAt(i));
      }

      const unassignedMarkers = markers.filter((marker) => {
        return marker.assigned === false;
      });
      let markersInDrawingBounds = 0;
      const capturedMarkers = [];
      unassignedMarkers.map((marker) => {
        let inPoly = false;
        if (drawingBounds.contains(marker.location)) {
          // console.log("marker location", marker.location);
          markersInDrawingBounds++;
          const numPointsInPath = drawingPath.getLength();
          let j = numPointsInPath - 1; //For our first comparison, we'll do i = the first point and j = the last point to do a collision detection for the last segment.
          for (let i = 0; i < numPointsInPath; i++) {
            const vertex1 = drawingPath.getAt(i);
            const vertex2 = drawingPath.getAt(j);
            // console.log(vertex1.lng());
            // console.log(marker.location.lng);
            if (
              (vertex1.lng() < marker.location.lng &&
                vertex2.lng() >= marker.location.lng) ||
              (vertex2.lng() < marker.location.lng &&
                vertex1.lng() >= marker.location.lng)
            ) {
              if (
                vertex1.lat() +
                  ((marker.location.lng - vertex1.lng()) /
                    (vertex2.lng() - vertex1.lng())) *
                    (vertex2.lat() - vertex1.lat()) <
                marker.location.lat
              ) {
                inPoly = !inPoly;
              }
            }
            j = i;
          }
        }
        if (inPoly) {
          capturedMarkers.push(marker);
        }
      });
      // toast.success(
      //   `${markersInDrawingBounds} markers detected in bounding box.`
      // );
      // console.log("orders to assign", ordersToAssign);

      if (capturedMarkers.length === 0) {
        toast.success("No locations selected.");
      } else {
        const ordersToAssign = capturedMarkers.reduce(
          (ordersToAssign, capturedMarker) => {
            return [
              ...ordersToAssign,
              ...capturedMarker.data.orders.map((order) => {
                return order.order;
              }),
            ];
          },
          []
        );
        assignOrders(ordersToAssign);
        toast.success(
          `${capturedMarkers.length} locations selected with ${ordersToAssign.length} orders total.`
        );
      }

      // console.log("drawing bounds", drawingBounds);
      currentDrawing.setPath([]);
      currentOverlay.setPath([]);
      startCircle?.setVisible(false);
      setIsDrawing(false);
      setDrawingModeActive(false);
      // console.log("remove and hide drawing circle and path");
    }
  };
  // console.log("is drawing", isDrawing);
  // console.log("is drawing mode active", drawingModeActive);

  // console.log("mapref zoomlevel", mapRef.current?.zoom);
  // console.log("mapped zoomlevel", mapRange(mapRef.current?.zoom, 10, 15, 5, 1));
  useEffect(() => {
    // console.log("initialize drawing features");
    if (mapsLibrary) {
      setCurrentDrawing(new mapsLibrary.Polyline({ clickable: false }));
      setCurrentOverlay(
        new mapsLibrary.Polygon({ clickable: false, strokeOpacity: 0 })
      );
      setStartCircle(
        new mapsLibrary.Circle({
          clickable: false,
          fillColor: "rgba(0,0,0,.3)",
          strokeColor: "black",
          radius: 1000,
          visible: false,
        })
      );
    }
  }, [mapsLibrary]);
  // useEffect(()=>{

  useEffect(() => {
    // console.log("how often this run");
    currentDrawing?.setMap(mapRef.current);
    if (drawingMethod === drawingMethods.autocompleteWithOverlay) {
      currentOverlay?.setMap(mapRef.current);
    }
    if (drawingMethod === drawingMethods.finishLine) {
      startCircle?.setMap(mapRef.current);
    }
    // console.log("maps library", mapsLibrary);
    // console.log("current drawing exists", currentDrawing);
  }, [currentDrawing, drawingMethod]);

  // },[currentDrawing])

  // console.log("initial center coord", initialCenterCoord);
  // console.log("hovered marker from DiliMap", hoveredMarker);
  // const testRef = useRef();
  return apiKey && initialCenterCoord ? (
    <APIProvider apiKey={apiKey}>
      <div
        style={{
          position: "relative",
          height: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            zIndex: 2,
            display: "flex",
            justifyContent: "center",
            width: "100%",
            paddingTop: ".5rem",
            pointerEvents: "none",
          }}
        >
          {/* <div
            style={{
              backgroundColor:
                drawingMethod === drawingMethods.autocompleteWithOverlay
                  ? "rgb(220,220,220)"
                  : "white",
              boxShadow: "0px 2px 5px 0px rgb(0,0,0,.2)",
              padding: ".5rem 1rem",
              borderRadius: ".4rem",
              fontWeight: 600,
              cursor: "pointer",
              pointerEvents: "auto",
              marginRight: ".2rem",
            }}
            onClick={() => {
              setDrawingMethod(drawingMethods.autocompleteWithOverlay);
            }}
          >
            Overlay
          </div>
          <div
            style={{
              backgroundColor:
                drawingMethod === drawingMethods.finishLine
                  ? "rgb(220,220,220)"
                  : "white",
              boxShadow: "0px 2px 5px 0px rgb(0,0,0,.2)",
              padding: ".5rem 1rem",
              borderRadius: ".4rem",
              fontWeight: 600,
              cursor: "pointer",
              pointerEvents: "auto",
              marginRight: ".2rem",
            }}
            onClick={() => {
              setDrawingMethod(drawingMethods.finishLine);
            }}
          >
            Line
          </div> */}
          {showDrawToAssignButton && (
            <div
              style={{
                backgroundColor: drawingModeActive
                  ? "rgb(220,220,220)"
                  : "white",
                boxShadow: "0px 2px 5px 0px rgb(0,0,0,.2)",
                padding: ".5rem 1rem",
                borderRadius: ".4rem",
                fontWeight: 600,
                cursor: "pointer",
                pointerEvents: "auto",
              }}
              onClick={toggleDrawingMode}
            >
              Draw to Assign
            </div>
          )}
        </div>
        <Map
          clickableIcons={!drawingModeActive}
          onMousemove={handleUpdateDrawing}
          onClick={startOrEndDrawing}
          onContextmenu={cancelDrawing}
          className={`map-style ${
            drawingModeActive ? "map-style-drawmode" : ""
          }`}
          onDragend={() => {
            //GOOGLE MAPS HAS AN ERROR WHERE SOMETIMES WHEN YOU CLICK, INSTEAD OF CALLING THE CLICK EVENT
            //IT CALLS THE DRAGSTART AND DRAGEND EVENTS CONSECUTIVELY WITHOUT DRAG/CENTER_CHANGED/BOUNDS_CHANGED IN BETWEEN
            //WHICH COMPLETELY DISABLES THE MOUSEMOVE EVENT AND DRAGGING FUNCTIONALITY UNTIL USER TRIES TO DRAG THE MAP TWO TIMES
            //THIS RESULTS IN THE DRAWING FUNCTIONALITY BREAKING AS WELL AS BEING ABLE TO MOVE THE MAP AROUND (UNTIL YOU TRY IT TWICE IN A ROW)
            //CALLING THIS AFTER DRAG END CAUSES IT TO RE-ENABLE THE MOUSEMOVE EVENT.
            // console.log("Mouse drag end");
            setTimeout(() => {
              // console.log("forced set center on mouse drag end");
              mapRef.current.setCenter(mapRef.current.getCenter());
            }, 50);
          }}
          streetViewControl
          fullscreenControl
          mapId="DEMO_MAP_ID" //Need to make a Map ID in the developer console to enable styling? but using DEMO_MAP_ID is enough to enable advanced markers. https://developers.google.com/maps/documentation/javascript/map-ids/mapid-over
          //May need to change the mapId however in case they stop it from working later?
          // 29.9245514,-95.5408477
          defaultCenter={initialCenterCoord}
          // onDrag={(e) => {
          //   // console.log("dragged", e.map.getCenter().lat());
          //   // console.log("dragged", e);
          //   console.log("dragged", e.map.data.map.center);
          //   setCurrentCoord({
          //     lat: e.map.data.map.center.lat(),
          //     lng: e.map.data.map.center.lng(),
          //   });
          // }}
          // center={currentCoord}
          defaultZoom={11.2}
          maxZoom={20}
          minZoom={4}
          zoomControl={zoomControl}
          gestureHandling={"greedy"}
          disableDefaultUI={true}
        >
          {markers && (
            <PoiMarkers
              clickable={!drawingModeActive}
              pointsOfInterest={markers}
              hoveredMarker={hoveredMarker}
              assignOrders={assignOrders}
            />
          )}
          {route && (
            <MapRoute
              route={route}
              legStatuses={legStatuses}
              simple={simpleRoute}
              closeInfoWindowNotif={closeInfoWindowNotif}
            />
          )}
          <MapRefSetter
            mapRefToSet={mapRef}
            mapsLibraryRef={mapsLibraryRef}
            coreLibraryRef={coreLibraryRef}
            geometryLibraryRef={geometryLibraryRef}
          />
        </Map>
        {/* {
      optimizedStopsTest &&
      <PoiMarkers
      pointsOfInterest={optimizedStopsTest.}
      />} */}
      </div>
    </APIProvider>
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        minHeight: "30px",
        display: "grid",
        placeContent: "center",
      }}
    >
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
};
